/* jshint esversion: 8 */
/* jshint node: true */

const sidebarItems = [
  {
    id: "DAT",
    location: "sidebar",
    name: "Datasets",
    desc: "",
    isActive: true,
    routePath: "/datasets",
    fontAwesomeIconClasses: "fas fa-download",
  },
  // {
  //   id: "EVAL",
  //   location: "sidebar",
  //   name: "Evaluations",
  //   desc: "",
  //   isActive: true,
  //   routePath: "/evaluations",
  //   fontAwesomeIconClasses: "fas fa-list-ul",
  // },
  // {
  //   id: "ADDL",
  //   location: "sidebar",
  //   name: "Additional Data",
  //   desc: "",
  //   isActive: true,
  //   routePath: "/additionalData",
  //   fontAwesomeIconClasses: "fas fa-chart-pie",
  // },
  // {
  //   id: "SRC",
  //   location: "sidebar",
  //   name: "Data Sources",
  //   desc: "",
  //   isActive: true,
  //   routePath: "/dataSources",
  //   fontAwesomeIconClasses: "fas fa-database",
  // },
  // {
  //   id: "HC-MAP",
  //   location: "sidebar",
  //   name: "Data Alignment",
  //   desc: "",
  //   isActive: true,
  //   routePath: "/daaMap1",
  //   fontAwesomeIconClasses: "fas fa-arrows-alt",
  // },
  {
    id: "CAL",
    location: "sidebar",
    name: "Data Calendar",
    desc: "",
    isActive: true,
    routePath: "/calendar",
    fontAwesomeIconClasses: "far fa-calendar-alt",
  },
  // {
  //   id: "FAQ",
  //   location: "sidebar",
  //   name: "F A Q's",
  //   desc: "",
  //   isActive: true,
  //   routePath: "/faqs",
  //   fontAwesomeIconClasses: "fas fa-question-circle",
  // },
  // {
  //   id: "GLO",
  //   location: "sidebar",
  //   name: "Glossary",
  //   desc: "",
  //   isActive: true,
  //   routePath: "/glossary",
  //   fontAwesomeIconClasses: "far fa-list-alt",
  // },
];

export default sidebarItems;
